import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './lang'
import FastClick from 'fastclick'
import { formatNum, mul, gt } from './utils/number'

import './assets/js/rem'
// 样式配置
import './assets/stylus/index.styl'


// 避免浏览器兼容问题引起的点击问题
if ('addEventListener' in document && 'ontouchstart' in window) {
  FastClick.prototype.focus = function (targetElement) {
    targetElement.focus()
  }
  document.addEventListener('DOMContentLoaded', function () {
    FastClick.attach(document.body)
  }, false)
}

// 非生产环境开启 vConsole
if (process.env.VUE_APP_CONSOLE === 'show') {
  const VConsole = require('vconsole')
  const vConsole = new VConsole()
  console.log(vConsole.version)
}

const app = createApp(App)

app.config.globalProperties.$filters = {
  // 股票涨幅过滤
  rangeFilter(num) {
    let val = formatNum(mul(Number(num), 100), 2)
    val = gt(val, 0)?'+'+val:val
    return   val + "%"
  }
}

app.use(store).use(router).use(i18n).mount('#app')
